import moment from "moment"

import { ISignaturePage } from "./types"

import { useDeviceType } from "@hooks/useDeviceType"
import { ComponentsHeader } from "@primitive/sectionHeadings"
import { Flex, Empty, Button, Pagination, Loader, Container, ToolTip, Table } from "@ui/index"

import imgEmty from '@img/empty.svg'
import imgAccessDenied from '@img/access_denied.svg'
import { IconSignature, IconTelegram } from "@img/icons"
import logoModSkill from '@img/logo_modskill.svg'
import logoYaSkill from '@img/logo_yaskill.svg'

import css from './ui.module.scss'


/** Страница - Договора на подпись */
export const SignaturePage = ({
    isAccessDenied, isLoadingPage, txtSearch, filterIsOpen, filterIsActivate, paginationPageNumber,
    primaryList, primaryListPageSize, primaryListTotalCount, primaryListNew, primaryListDelayedCall,
    primaryListExecution, primaryListCanceled, primaryListNotClient, primaryListIgnore,

    setTxtSearch, loadPrimaryData, handleApplyClearFilter, handleOpenCardSignature, handleSendToTelegram
}: ISignaturePage) => {
    const deviceType = useDeviceType()

    /** Вазвращает лого сайта */
    const returnLogo = (dbName: string) => {
        switch (dbName) {
            case 'modern_academy': return logoModSkill
            case 'yaskill': return logoYaSkill
        }
    }

    return <div className={css['container']}>

        <ComponentsHeader
            isAccessDenied={isAccessDenied.value}
            headerIcon={<IconSignature width="20px" height="20px" />}
            headerTitle="Договора на подпись"
            txtSearch={txtSearch}
            txtSearchTooltip={<>Поиск по:<br />✓ Номеру заявки<br />✓ Номеру договора<br />✓ ФИО клиента<br />✓ Телефону клиента<br />✓ Email клиента<br />✓ Комментарию</>}
            txtSearchOnChange={(e) => setTxtSearch(e.target.value)}
            txtSearchClearOnClick={() => setTxtSearch('')}
            btnUpdateOnClick={() => loadPrimaryData(txtSearch)}
            btnFilterOnClick={() => filterIsOpen.setValue(true)}
            btnFilterClearOnClick={() => handleApplyClearFilter('clear')}
            filterIsActivate={filterIsActivate.value}
        />

        <Table.Container>
            <Loader isOpen={isLoadingPage} backdrop={true} color="var(--color_txt_accent)" title="Загрузка..." />
            <Table.Header paddingLeft="55px" paddingRight="66px" classNameContainer={css['hidden_690']} classNameContent={css['table_grid_columns_header']}>
                <div style={{ textAlign: 'center' }}>
                    <p>№ заявки</p>
                    <p>№ договора</p>
                </div>

                <p>ФИО клиента</p>

                <div>
                    <p>Комментарий</p>
                    <p>Телефон / Email</p>
                </div>

                <p className={css['hidden_900']} style={{ textAlign: 'center' }}>Отложенный<br />звонок</p>
                <p className={css['hidden_1100']} style={{ textAlign: 'center' }}>Статус<br />заявки</p>
                <p className={css['hidden_1000']} style={{ textAlign: 'center' }}>Дата<br />создания</p>
            </Table.Header>

            <Table.Content>
                {primaryList.length === 0
                    ? <Empty image={isAccessDenied.value === false ? imgEmty : imgAccessDenied} title={isAccessDenied.value === false ? 'Данные отсутствуют' : 'Доступ запрещён'} />
                    : primaryList.map(item => {
                        return (
                            <Table.Row key={`${item.contractID}`} className={css['table_grid_columns_content']} onClick={() => handleOpenCardSignature(true, item.contractID, item.contractNumber)}>
                                <img src={returnLogo(item.data_base)} alt="Лого сайта" />

                                <div style={{
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    padding: '2px 0px',
                                    lineHeight: '130%',
                                    background: item.contractStatusCallCenterColor,
                                    borderRadius: 'calc(var(--border_radius_default) - 4px)',
                                }}>
                                    <p>{item.applicationID}</p>
                                    <p>{item.contractNumber}</p>
                                </div>

                                <div style={{textWrap: 'nowrap', overflow: 'hidden'}}>
                                    <p>{`${item.lastName}`}</p>
                                    <p>{`${item.firstName} ${item.secondName}`.trim()}</p>
                                </div>

                                <div className={css['hidden_690']} style={{textWrap: 'nowrap', overflow: 'hidden'}}>
                                    <p>{item.commentCallCenter || '------'}</p>

                                    <Flex gap="6px" flexDirection="row">
                                        <p style={{ opacity: '.7' }}>{item.phoneNumber || '- --- --- -- --'} / {item.email || '------'}</p>
                                    </Flex>
                                </div>

                                <div className={css['hidden_900']} style={{ textAlign: 'center' }}>
                                    <p>{item.dateNextCall || '--.--.----'}</p>
                                    <p>{item.timeNextCall || '--:--:--'}</p>
                                </div>

                                <div className={css['hidden_1100']} style={{
                                    textAlign: 'center',
                                    fontWeight: '600',
                                    color: item.contractStatusCallCenterColor
                                }}>{item.contractStatusCallCenterName}</div>

                                <div className={css['hidden_1000']} style={{ textAlign: 'center' }}>
                                    <p>{moment(item.dateCreate).format('DD.MM.YYYY')}</p>
                                    <p>{moment(item.dateCreate).format('HH:mm:ss')}</p>
                                </div>

                                <Flex flexDirection="row" alignItems="center" justifyContent="center">
                                    <ToolTip title='ИКТ - Договора на подпись' placement="bottomRight">
                                        <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'} onClick={(e) => {
                                            handleSendToTelegram(item.contractID)
                                            e.stopPropagation()
                                        }}><IconTelegram width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                    </ToolTip>
                                </Flex>
                            </Table.Row>
                        )
                    })
                }
            </Table.Content>
        </Table.Container>



        <Container padding="6px" className={css['footer']} overflow="visible">
            <Flex gap="4px" flexDirection="row">
                <ToolTip title='Общее количество' placement="topLeft">
                    <p className={css['stat_all']}>{primaryListTotalCount}</p>
                </ToolTip>

                {primaryListNew > 0 && 
                    <ToolTip title='Новый' placement="topLeft">
                        <p className={css['stat_new']}>{primaryListNew}</p>
                    </ToolTip>
                }

                {primaryListDelayedCall > 0 && 
                    <ToolTip title='Отложенный звонок' placement="topLeft">
                        <p className={css['stat_delayed']}>{primaryListDelayedCall}</p>
                    </ToolTip>
                }
            </Flex>

            <Pagination
                totalCount={primaryListTotalCount}
                pageSize={primaryListPageSize}
                currentPage={paginationPageNumber.value}
                onChange={(e) => paginationPageNumber.setValue(e)}
            />
        </Container>
    </div>
}